import { MapPin, IndianRupee, Clock, Users, CheckCircle2, Laptop } from "lucide-react";
import { UserAvatar } from "@/components/UserAvatar";
import { ago } from "@/lib/api";

export const jobPoster = (j) => j.author || j.poster || j.posted_by_user || j.user;

export const JobRow = ({ job, onOpen }) => {
  const poster = jobPoster(job);
  const count = job.applications_count ?? job.applicants_count ?? job.applications?.length;
  return (
    <button onClick={() => onOpen(job)} className="tm-card tm-lift block w-full p-6 text-left" data-testid={`job-card-${job.id}`}>
      <div className="flex items-start gap-4">
        <UserAvatar user={poster} />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="font-display text-base font-bold text-tm-green">{job.title}</h3>
            {job.applied && <span className="flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700"><CheckCircle2 className="h-3 w-3" />Applied</span>}
          </div>
          <p className="text-sm text-slate-500">{poster?.full_name}{job.created_at && ` · ${ago(job.created_at)}`}</p>
          <p className="mt-3 line-clamp-2 text-sm text-slate-700">{job.description}</p>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-600">
            {(job.category || job.type) && <span className="rounded-full bg-tm-green/10 px-2.5 py-1 font-semibold text-tm-green">{job.category || job.type}</span>}
            {job.type && job.category && <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{job.type}</span>}
            {job.work_mode && <span className="flex items-center gap-1"><Laptop className="h-3.5 w-3.5" />{job.work_mode}</span>}
            {job.city && <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{job.city}</span>}
            {(job.salary || job.budget) && <span className="flex items-center gap-1"><IndianRupee className="h-3.5 w-3.5" />{(job.salary || job.budget).replace("₹", "")}</span>}
            {count != null && <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{count} {job.responses != null ? "responses" : "applicants"}</span>}
            {job.responses != null && count == null && <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{job.responses} responses</span>}
          </div>
        </div>
      </div>
    </button>
  );
};
